import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const UiCompTypeAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();


  // Initialize with actual JSON obj.  If not, will get error.
  const [uiCompTypeAttrs, setUiCompTypeAttrs] = useState({
    name: '',
    description: '',
    dataSrcType: '',
    dataSrcStyle: '',
    dataLenStyle: '',
    attrList: ''
  });

  // ##### Enhancement: Fetch through API or config. #####

  const dataSrcTypeOptions = [
    { key: "DATAPOINT", value: "DATAPOINT" },
    { key: "ALARM",     value: "ALARM" }
  ];

  const dataSrcStyleOptions = [
    { key: "FIXED",    value: "FIXED" },
    { key: "ADAPTIVE", value: "ADAPTIVE" }
  ];

  const dataLenStyleOptions = [
    { key: "POINT",  value: "POINT" },
    { key: "SERIES", value: "SERIES" }
  ];


  // Ui Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setUiCompTypeAttrs({ ...uiCompTypeAttrs, [e.target.name]: e.target.value })
  }

  const onDataSrcTypeSelect = (key, event) => {
    setUiCompTypeAttrs({ ...uiCompTypeAttrs, dataSrcType: key })
  };

  const onDataSrcStyleSelect = (key, event) => {
    setUiCompTypeAttrs({ ...uiCompTypeAttrs, dataSrcStyle: key })
  };

  const onDataLengthSelect = (key, event) => {
    setUiCompTypeAttrs({ ...uiCompTypeAttrs, dataLenStyle: key })
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!uiCompTypeAttrs.name || uiCompTypeAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_uiCompType_name"));
    } else if (uiCompTypeAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + "100");
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-comp-types?name=" + uiCompTypeAttrs.name);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_Name_taken"));
        } else {
          validateOtherFields();
        }

        return;

      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (!uiCompTypeAttrs.description || uiCompTypeAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (uiCompTypeAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "250");

    } else if (!uiCompTypeAttrs.attrList || uiCompTypeAttrs.attrList.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_attr_list"));
    } else if (uiCompTypeAttrs.attrList.length > 1000) {
      setErrMsg(t("I18N_ERR_Max_len_attr_list") + "1000");

    } else if (uiCompTypeAttrs.dataSrcType === '') {
      setErrMsg(t("I18N_ERR_Need_dataSrcType"));

    } else if (uiCompTypeAttrs.dataSrcStyle === '') {
      setErrMsg(t("I18N_ERR_Need_dataSrcStyle"));

    } else if (uiCompTypeAttrs.dataLenStyle === '') {
      setErrMsg(t("I18N_ERR_Need_dataLenStyle"));

    } else {
      setErrMsg('');
      createNewUiCompType();
    }
  }

  const createNewUiCompType = () => {

    const reqBody = JSON.parse(JSON.stringify(uiCompTypeAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("ui-comp-types", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_UiCompType")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UiCompType_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Name")}: *</Col>
              <Col>{t("I18N_Description")}: *</Col>
              <Col md={{ span: 6}}>{t("I18N_Attr_list")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                       value={uiCompTypeAttrs.name} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description" value={uiCompTypeAttrs.description}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={{ span: 6}}>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrList" value={uiCompTypeAttrs.attrList}
                          onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Data_src_type")}: *</Col>
              <Col>{t("I18N_Data_src_style")}: *</Col>
              <Col>{t("I18N_Data_len_style")}: *</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!uiCompTypeAttrs.dataSrcType ? t("common:I18N_DROPDOWN_PROMPT") :
                         t("common:I18N_" + (dataSrcTypeOptions.find( ({ key }) => key === uiCompTypeAttrs.dataSrcType )).value) }
                  onSelect={onDataSrcTypeSelect}>
                  {dataSrcTypeOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("common:I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!uiCompTypeAttrs.dataSrcStyle ? t("common:I18N_DROPDOWN_PROMPT") :
                         t("common:I18N_" + (dataSrcStyleOptions.find( ({ key }) => key === uiCompTypeAttrs.dataSrcStyle )).value) }
                  onSelect={onDataSrcStyleSelect}>
                  {dataSrcStyleOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("common:I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!uiCompTypeAttrs.dataLenStyle ? t("common:I18N_DROPDOWN_PROMPT") :
                         t("common:I18N_" + (dataLenStyleOptions.find( ({ key }) => key === uiCompTypeAttrs.dataLenStyle )).value) }
                  onSelect={onDataLengthSelect}>
                  {dataLenStyleOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("common:I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default UiCompTypeAdminNewView;
